import {
	JSErrorBoundary as JSErrorBoundaryImpl,
	type JSErrorBoundaryProps as JSErrorBoundaryPropsImpl,
} from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';

/**
 * @deprecated Use `@jira/platform__js-error-boundary` instead
 */
export const JSErrorBoundary = JSErrorBoundaryImpl;

/**
 * @deprecated Use `@jira/platform__js-error-boundary` instead
 */
// eslint-disable-next-line jira/export/restrict-types-re-export
export type JSErrorBoundaryProps = JSErrorBoundaryPropsImpl;
